<script setup lang="ts">
import { api } from '@/api';
import { TenantLicenseDataDto } from '@/api/generator';
import { useVeeForm } from '@/components/forms/useVeeForm';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { useLoading } from '@/utils/useLoading';
import { onMounted, ref } from 'vue';
import LicenseForm from './components/LicenseForm.vue';

const hasLicensePlan = ref<boolean>(false);

const { action: loadLicense, loadingFirstTime } = useLoading(async () => {
  const { result } = await api.licenseApi.getLicenseDataInfo();

  if (result) {
    resetForm({ values: result });
    hasLicensePlan.value = !!result.licensePlan;
  }
}, true);

const {
  form: { resetForm },
} = useVeeForm<TenantLicenseDataDto>({
  mode: 'details',
});

onMounted(loadLicense);
</script>

<template>
  <BasePage :loading="loadingFirstTime">
    <template #title>
      <BasePageTitle :title="$t('License_other')" />
    </template>

    <v-sheet class="pa-4">
      <v-alert
        v-if="hasLicensePlan === false"
        class="mb-4"
        density="compact"
        variant="outlined"
        type="error"
        color="error-lighten-1"
      >
        {{ $t('LicenseNotFound') }}</v-alert
      >
      <LicenseForm v-if="hasLicensePlan" />
    </v-sheet>
  </BasePage>
</template>
